export const setCurrentPage = (currentPage: number, amountOfPages: number) => {
  switch (true) {
    case currentPage > amountOfPages:
      return amountOfPages;
    case currentPage < 1:
      return 1;
    default:
      return currentPage;
  }
};
